import React from "react";
import { Check } from "lucide-react";
import { archetypesFor, groupsFor, secondaryBlockReason } from "../../lib/archetypes";

// Cards grouped by Group. For the Secondary slot, pairing rules grey out cards with a tooltip explaining why.
const FIT_COLOR = { Strong: "#4ade80", Moderate: "#facc15", Weak: "#f87171" };

export function ArchetypeCardGrid({ side, slot, value, primaryId, chosenIds, editable, onChange, color, testid, fits }) {
  const items = archetypesFor(side, chosenIds);
  return (
    <div className="space-y-4" data-testid={testid}>
      {groupsFor(side, chosenIds).map(group => (
        <div key={group}>
          <div className="text-[9px] uppercase tracking-[0.4em] font-bold text-[#757575] mb-2">{group}</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-2">
            {items.filter(a => a.group === group).map(a => {
              const block = slot === "secondary" ? secondaryBlockReason(primaryId, a) : null;
              const selected = value === a.id;
              const disabled = !editable || !!block;
              return (
                <button key={a.id} type="button" disabled={disabled} title={block || a.description || undefined}
                  onClick={() => onChange(selected ? null : a.id)}
                  className={`text-left p-3 border transition-colors ${selected ? "bg-[#1a1a1a]" : "bg-[#141414] border-white/10"} ${block ? "opacity-35 cursor-not-allowed" : editable ? "hover:border-white/30" : "cursor-default"}`}
                  style={selected ? { borderColor: color } : undefined}
                  data-testid={`${testid}-${a.id}`} aria-pressed={selected}>
                  <div className="flex items-start justify-between gap-2">
                    <div className="text-sm font-semibold text-white leading-tight">{fits?.[a.id] && <span className="mr-2 text-[10px] font-bold tabular-nums" style={{ color: FIT_COLOR[fits[a.id].label] }} title={fits[a.id].reason} data-testid={`${testid}-${a.id}-fit`}>{fits[a.id].fit}%</span>}{a.name}{a.status === "retired" && <span className="ml-2 text-[8px] uppercase tracking-[0.2em] px-1.5 py-0.5 border border-[#f59e0b]/40 text-[#f59e0b]">retired</span>}</div>
                    {selected && <Check className="w-4 h-4 shrink-0" style={{ color }} />}
                  </div>
                  {a.description && <div className="text-[11px] text-[#a0a0a0] mt-1 leading-snug">{a.description}</div>}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
